export enum ETabs {
  PUBLISHED = 'published ',
  UNPUBLISHED = 'unpublished ',
}
